module.exports = __webpack_public_path__ + "31f6d88e190bb2aab63a53b8be8f0dbc.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1hour_show_labels.png
// module id = 879
// module chunks = 7